module.exports = new Promise((resolve, reject) => {
        Promise.resolve(window.__mf_remotes_map__ || {})
        .then((remotesMap) => {
            if (!remotesMap['webcommon']) {
                const staticUrl = window._endpoints['webcommon'] + '/remoteEntry.js';
                if (undefined) {
                    console.warn('MF: [webcommon] remote url not found in config map, fallback to ' + staticUrl);
                }
                return staticUrl;
            }
            return remotesMap['webcommon'] + '/remoteEntry.js';
        })
        .then((remoteEntryUrl) => {
            return new Promise((_resolve, _reject) => {
                if (typeof webcommon !== 'undefined') {
                    return _resolve();
                }
                __webpack_require__.l(
                    remoteEntryUrl,
                    function(event) {
                        if (typeof webcommon !== 'undefined') {
                            return _resolve();
                        }
                        var scriptSrc = event && event.target && event.target.src;
                        var _error = new Error('Load script failed: ' + scriptSrc);
                        _error.name = 'ScriptExternalLoadError';
                        _error.request = scriptSrc;
                        _reject(_error);
                    },
                    'webcommon',
                );
            });
        })
        .then(() =>
            resolve({
                get: async (moduleRequest) => {
                    // Allow import non-existing module path .eg ./exposes/non-existing-path.
                    // If there is error in .get(moduleRequest), return empty module in its place
                    // and log the error in console.

                    // fallback module getter, returning empty module
                    let getter = () => ({ __esModule: true });
                    try {
                        getter = await webcommon.get(moduleRequest);
                    } catch (err) {
                        console.error('Error loading module from webcommon:', err.message, 'Providing fallback empty module.');
                    }
                    const moduleResult = getter();
                    return () => moduleResult;
                },
                init: (sharedScope) => {
                    
                    try {
                        return webcommon.init(sharedScope);
                    } catch (e) {
                        console.log('remote container [webcommon] already initialized');
                    }
                },
            })
        )
        .catch((err) => {
            console.warn(err);
            reject(err);
        });
    });